import { Alert } from '@vibTheme/components/VibAlert';

type Props = {
  /** Como a tela se chama, para o aviso falar dela e não de "o painel" em todo lugar. */
  oQue: string;
};

/**
 * O que o painel e os detalhes dele mostram a quem eles não têm como servir.
 *
 * Fechado COM MOTIVO, e não em branco: sem isto a pessoa vê o seletor sem comunidade nenhuma e a
 * tela vazia, sem nada explicando por quê — e antes disso via a própria comunidade listada como
 * "Afiliado", que é pior, porque o número que sai dali responde por uma comissão que não existe.
 */
export const SemPapelDeComissao = (props: Props) => (
  <Alert variant="info">
    {props.oQue} ainda não está disponível para as suas comunidades: os números
    daqui saem da sua comissão ou do seu acesso aos números do produto, e
    nenhuma delas entra nesse corte. Os relatórios que você tem permissão para
    ver continuam no menu.
  </Alert>
);
